export const dummyTables = [
  { id: 'table-1', name: 'Historical Stock Prices', icon: '📈' },
  { id: 'table-2', name: 'Company Financials', icon: '📊' },
  { id: 'table-3', name: 'Analyst Ratings', icon: '⭐' },
  { id: 'table-4', name: 'Market News Sentiment', icon: '📰' },
  { id: 'table-5', name: 'Economic Indicators', icon: '🌍' },
  { id: 'table-6', name: 'Options Data', icon: '📋' },
  { id: 'table-7', name: 'Insider Trading', icon: '👥' },
]

export const dummyNodes = [
  // Data Sources
  { id: 'node-1', name: 'Data Source', type: 'source', icon: '📥' },
  { id: 'node-2', name: 'API Connector', type: 'source', icon: '🔌' },
  { id: 'node-3', name: 'Database Query', type: 'source', icon: '🗄️' },
  
  // Processing Nodes
  { id: 'node-4', name: 'Filter Stocks', type: 'process', icon: '🔍' },
  { id: 'node-5', name: 'Generate Chart', type: 'process', icon: '📈' },
  { id: 'node-6', name: 'Data Transformation', type: 'process', icon: '⚙️' },
  { id: 'node-7', name: 'Calculate Metrics', type: 'process', icon: '🧮' },
  { id: 'node-8', name: 'Aggregate Data', type: 'process', icon: '📊' },
  
  // AI Nodes
  { id: 'node-9', name: 'LLM Analysis', type: 'ai', icon: '🧠' },
  { id: 'node-10', name: 'Sentiment Analysis', type: 'ai', icon: '😊' },
  { id: 'node-11', name: 'Pattern Recognition', type: 'ai', icon: '🔍' },
  { id: 'node-12', name: 'Prediction Model', type: 'ai', icon: '🔮' },
  
  // Action Nodes
  { id: 'node-13', name: 'Email Alert', type: 'action', icon: '📧' },
  { id: 'node-14', name: 'Trade Execution', type: 'action', icon: '🚀' },
  { id: 'node-15', name: 'SMS Notification', type: 'action', icon: '📱' },
  { id: 'node-16', name: 'Webhook Trigger', type: 'action', icon: '🌐' },
  { id: 'node-17', name: 'Slack Message', type: 'action', icon: '💬' },
  
  // Logic Nodes
  { id: 'node-18', name: 'Conditional Logic', type: 'logic', icon: '➡️' },
  { id: 'node-19', name: 'Logical AND', type: 'logic', icon: '∧' },
  { id: 'node-20', name: 'Logical OR', type: 'logic', icon: '∨' },
  { id: 'node-21', name: 'Logical NOT', type: 'logic', icon: '¬' },
  { id: 'node-22', name: 'Switch Case', type: 'logic', icon: '🔀' },
  { id: 'node-23', name: 'Delay Timer', type: 'logic', icon: '⏰' },
] 